export enum EmptyStateType {
  CART_EMPTY = 'cart_empty',
  CATALOG_EMPTY_BY_FILTERS = 'catalog_empty_by_filters',
  CATALOG_EMPTY_BY_SEARCH = 'catalog_empty_by_search',
  ORDERS_EMPTY = 'order_empty',
  ACTIVE_ORDERS_EMPTY = 'active_order_empty',
  CATALOG_EMPTY_BY_CATEGORY = 'catalog_empty_by_category',
  FAVORITES_EMPTY = 'favorites_empty',
  ADDRESSES_EMPTY = 'addresses_empty',
  PROFILE_EMPTY = 'profile_empty',
  PRODUCT_EMPTY = 'product_empty',
  FORM_SUCCESS = 'form_success',
  NO_CONNECTION = 'no_connection',
  NOT_FOUND = 'not_found',
  NOT_FOUND_CATEGORY = 'not_found_category',
  NOT_FOUND_SHOP = 'not_found_shop',
  RETURNS_EMPTY = 'returns_empty',
}
